<template>
  <multiselect
    v-model="selected"
    :options="options"
    :custom-label="labelSite"
    placeholder=""
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading"
    :disabled="isLoading"
    @input="onChange"
    label="nome_fantasia"
    track-by="id"
  />
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['alreadySelected', 'isRequired'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      if (e == null) {
        this.$emit('siteSelectChange', '');
        return;
      }
      this.$emit('siteSelectChange', e);
    },
    labelSite({ nome_fantasia }) {
      return `${nome_fantasia}`;
    }
  },

  watch: {},

  created() {
    this.isLoading = true;
    this.selected = '';
    const sites = this.$store.state.user.info.hasOwnProperty('sites') ? this.$store.state.user.info.sites : null;
    let filter = `id_empresa=${this.$store.state.user.info.id_empresa}`;
    if (sites != null && sites != '[]' && sites != ' ' && sites != '') {
      filter += ` and business_logic.localidade_web.id in (${sites})`;
    }
    this.$atenaList
      .getSites({
        columns: 'id, id_localidades, nome_fantasia',
        filter: filter,
        order: 'id'
      })
      .then((res) => {
        this.options = [{ id: '', id_localidades: [], nome_fantasia: this.$i18n.t('Selecione') }];
        this.options = this.options.concat(res.data);
        if (this.alreadySelected) this.selected = this.alreadySelected;
        else this.selected = { id: '', id_localidades: [], nome_fantasia: this.$i18n.t('Selecione') };
        this.isLoading = false;
      })
      .catch((err) => {
        this.isLoading = false;
        this.$notify({
          group: 'notifications-default',
          type: 'error',
          title: this.$i18n.t('Erro ao Carregar Dados'),
          text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
        });
      });
  }
};
</script>

<style lang="scss" scoped></style>
